import { useState, useEffect } from "react";
import { useRoute } from "wouter";



  type AllowedRoles =
    | "Manager"
    | "Planning Team"
    | "Appointment Team"
    | "Sales Order Team"
    | "Courier Team"
    | "Invoicing Team"
    | "Warehouse Team";

    
export function useGridRole(
  userRole: AllowedRoles,
  allowedRoles: readonly AllowedRoles[]
) {
  const routeToRoleName: Record<string, AllowedRoles> = {
    manager: "Manager",
    planner: "Planning Team",
    appointment: "Appointment Team",
    "sales-order": "Sales Order Team",
    courier: "Courier Team",
    invoice: "Invoicing Team",
    warehouse: "Warehouse Team",
  };

  const [match, params] = useRoute<{ role: string }>("/role/:role");
  const [gridRole, setGridRole] = useState<AllowedRoles>(
    userRole === "Manager"
      ? "Manager"
      : params && params.role && routeToRoleName[params.role]
      ? routeToRoleName[params.role]
      : userRole
  );

  useEffect(() => {
    if (params && params.role && routeToRoleName[params.role]) {
      if (userRole === "Manager") {
        setGridRole(routeToRoleName[params.role]);
      } else {
        setGridRole(routeToRoleName[params.role]);
      }
    }
  }, [params?.role, userRole]);

  return [gridRole, setGridRole] as const;
}
